import { initPoint } from 'cml-script';
export * from 'cml-script';

export const renderCluster = ({ addSource, plots }) => {
  let source = JSON.parse(
    JSON.stringify({
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [],
      },
      id: 'earthquakes_clusters',
      cluster: true,
      // clusterMaxZoom: 14, // Max zoom to cluster points on
      clusterRadius: 50,
    }),
  );
  plots.forEach((plot, index) => {
    let point = initPoint({
      coordinates: plot.centroid,
      properties: {
        id: plot._id,
        mag: 1,
        tsunami: 0,
      },
    });
    source.data.features.push(point);
  });
  let layers = [
    {
      id: 'clusters',
      type: 'circle',
      source: 'earthquakes_clusters',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': '#5EC4AC',
        'circle-radius': [
          'step',
          ['get', 'point_count'],
          15, //default
          10, // > 10 -> 20
          20,
          50, // > 50 -> 25
          25,
          100, // > 100 -> 30
          30,
          300, // > 300 -> 35
          35,
          500, // > 1000 -> 40
          40,
          1000, // > 1000 -> 45
          45,
        ],
      },
    },
    {
      id: 'cluster-count',
      type: 'symbol',
      source: 'earthquakes_clusters',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': ['get', 'point_count_abbreviated'],
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 14,
      },
      paint: {
        'text-color': '#ffffff',
      },
    },
    {
      id: 'unclustered-point',
      type: 'circle',
      source: 'earthquakes_clusters',
      filter: ['!', ['has', 'point_count']],
      paint: {
        'circle-color': '#5EC4AC',
        'circle-radius': 4,
      },
    },
  ];
  addSource({
    source,
    layers,
  });
};
export const ADMIN_ROUTES = {
  USER: '/admin/user',
  AUTH: '/admin/auth',
  SIGN_IN: '/admin/auth/sign-in',
  PLOTS_ACTIVITY: '/admin/plots-activity',
  PLOTS_FLAGGED: '/admin/plots-flagged',
  POOL: '/admin/pools',
  RESET_TEST_ENV: '/admin/reset-test-environment',
  MANAGE_USER: '/admin/manage-user',
  CONFIG: '/admin/config',
  BLOG_CATEGORY: '/admin/blog-category',
  BLOG: '/admin/blog',
  DASHBOARD: '/admin',
};

export const POST_STATUS = {
  published: 'published',
  daft: 'draft',
};

export const POST_PAGE_MODE = {
  view: 'view',
  create: 'create',
  update: 'update',
};

const Constants = {
  BACKEND_URL:
    process.env.REACT_APP_MODE !== 'dev'
      ? process.env.REACT_APP_BACKEND_URL
      : process.env.REACT_APP_BACKEND_URL_TEST,
  ACCESS_TOKEN: 'access_token',
  PUBLIC_USER_ACCESS_TOKEN: 'public_user_access_token',
  RESET_APP: 'store/reset',
  SIDEBAR_WIDTH: 298,
  SIDEBAR_MINI_WIDTH: 108,
  DRAWER_WIDTH: 250,
  ACCOUNT_DATA: 'account_data',
  ON_TEST_ENVIRONMENT: process.env.REACT_APP_RESET_ENVIRONMENT || false,
};

export const maxZoomCluster = 13;
export default Constants;
